import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../../layout/AuthLayout'
import classes from '../../../../../assets/module-css/AdminLayout.module.css'
import { Box, Text, Paper, TextInput, NumberInput, Checkbox, Switch, SimpleGrid, Select, Flex, Group, Button, Loader } from '@mantine/core'
import { useParams } from 'react-router-dom'
import { updateRoute } from '../../../../../store/dataRoute'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { useDispatch, useSelector } from 'react-redux'
import { quantityUnit, bundleUnit } from '../../../../../helper/master-unit'
import { validation } from '../../../../../plugins/validation'
import { useNavigate } from 'react-router-dom'
import { getAllSupplierList } from '../../../../../services/supplier'
import { useDebouncedCallback } from '@mantine/hooks'
import { IconTrash } from '@tabler/icons-react'
import { notificationSuccess, notificationError, loadingNotification, completedLoadingNotification } from '../../../../ui/Notifications'
import { getOrderItems } from '../../../../../store/orderItems'
import { addOrderProductItems } from '../../../../../services/orders'
import { calculation } from '../../../../../services/calculation'

const defaultVal = {
  product_name: '',
  original_name: '',
  supplier_id: null,
  image_url: 'https://asiacommerce.s3.ap-southeast-1.amazonaws.com/documents/orders/2688/dev/1637910099-image-loading.png',
  original_price: '',
  price: '',
  unit_name: 'pcs',
  quantity: '',
  base_unit_name: 'pcs',
  quantity_per_unit: '',
  weight: '',
  cbm_per_unit: '',
  bm: '',
  ppn: '',
  pph: ''
}

const defaultVariant = [
  {
    name: '',
    option: ''
  }
]

const formValidation = {
  product_name: {
    isError: false,
    message: ''
  },
  original_name: {
    isError: false,
    message: ''
  },
  image_url: {
    isError: false,
    message: ''
  },
  original_price: {
    isError: false,
    message: ''
  },
  price: {
    isError: false,
    message: ''
  },
  unit_name: {
    isError: false,
    message: ''
  },
  quantity: {
    isError: false,
    message: ''
  },
  base_unit_name: {
    isError: false,
    message: ''
  },
  quantity_per_unit: {
    isError: false,
    message: ''
  },
  weight: {
    isError: false,
    message: ''
  },
  cbm_per_unit: {
    isError: false,
    message: ''
  },
  bm: {
    isError: false,
    message: ''
  },
  ppn: {
    isError: false,
    message: ''
  },
  pph: {
    isError: false,
    message: ''
  },
}

const variantValidation = {
  name: {
    isError: false,
    message: ''
  },
  option: {
    isError: false,
    message: ''
  }
}

const FormAddProductManual = () => {
  const { isLoadingOrder, summary } = useSelector(state => state.order_detail)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [validationVariant, setValidationVariant] = useState(variantValidation)
  const [defaultImage, setDefaultImage] = useState(true)
  const [useBundle, setUseBundle] = useState(false)
  const [useVariant, setUseVariant] = useState(false)
  const [variantProduct, setVariantProduct] = useState(defaultVariant)
  const [loadingForm, setLoadingForm] = useState(false)
  const [loadingSupplier, setLoadingSupplier] = useState(true)
  const [supplierList, setSupplierList] = useState([])
  const [searchSupplier, setSearchSupplier] = useState('')

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Order',
      route: '/order/all'
    },
    {
      label: orderId,
      route: `/order/${orderId}`
    },
    {
      label: 'Add Product Manual',
      route: null
    },
  ]

  const handleGetListSupplier = useDebouncedCallback(async (supplierId) => {
    setLoadingSupplier(true)
    const parameter = {
      'filter[name][like]': searchSupplier,
      'page[num]': 1,
      'page[limit]': 10,
      'fields[supplier]': 'name'
    }

    try {
      const response = await getAllSupplierList(parameter)
      const dataSuppliers = response.data
      const remapDataSuppliers = dataSuppliers.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setSupplierList(remapDataSuppliers)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSupplier(false)
    }
  }, 300)

  const handleSubmitProduct = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    setValidationVariant(variantValidation)
    const validateForm = {
      product_name: form.product_name,
      original_name: form.original_name,
      image_url: form.image_url,
      original_price: `${form.original_price}`,
      price: `${form.price}`,
      unit_name: form.unit_name,
      quantity: `${form.quantity}`,
      base_unit_name: form.base_unit_name,
      quantity_per_unit: `${form.quantity_per_unit}`,
      weight: `${form.weight}`,
      cbm_per_unit: `${form.cbm_per_unit}`,
      bm: `${form.bm}`,
      ppn: `${form.ppn}`,
      pph: `${form.pph}`
    }
    if (!useBundle) {
      delete validateForm.base_unit_name
      delete validateForm.quantity_per_unit
    }
    const isErrorForm = validation(validateForm, setValidationForm)
    if (isErrorForm) {
      notificationError('Submit Product Error', 'Check recheck your form')
      setLoadingForm(false)
      return
    }

    if (useVariant) {
      let validateVariant = {}
      for (let i = 0; i < variantProduct.length; i++) {
        validateVariant = {
          name: variantProduct[i].name,
          option: variantProduct[i].option,
        }
      }
      const isErrorVariant = validation(validateVariant, setValidationVariant)
      if (isErrorVariant) {
        notificationError('Submit Product Error', 'Check recheck your form variant')
        setLoadingForm(false)
        return
      }
    }

    const payload = {
      items: []
    }

    const handleSetVariant = (useVariant, dataProduct, dataVariant) => {
      let data = []
      if (useVariant) {
        data = dataVariant
      } else {
        data.push({
          name: 'Product Name',
          option: dataProduct.product_name,
        })
      }
      return data
    }

    const addProduct = {
      product_id: null,
      origin_sku: null,
      ali_sku: null,
      supplier_id: form.supplier_id ? form.supplier_id : null,
      product_name: form.product_name,
      original_name: form.original_name,
      image_url: form.image_url,
      original_price: form.original_price,
      quantity: form.quantity,
      currency: summary.orderCurrency,
      base_unit_name: useBundle ? form.base_unit_name : 'pcs',
      quantity_per_unit: useBundle ? form.quantity_per_unit : 1,
      unit_name: form.unit_name,
      price: form.price,
      cost: form.price,
      weight: 0,
      sku_status: {
        id: 22,
      },
      rule: {
        weight_unit: 'KG',
        total_weight: 2,
        total_tax: 0,
        cbm_per_unit: form.cbm_per_unit,
        hscodes: null,
        taxes: [
          {
            label: 'BM',
            value: form.bm,
          },
          {
            label: 'PPH',
            value: form.pph,
          },
          {
            label: 'PPN',
            value: form.ppn,
          },
        ],
        weight: form.weight,
      },
      variants: handleSetVariant(useVariant, form, variantProduct)
    }
    payload.items.push(addProduct)
    try {
      const response = await addOrderProductItems(orderId, payload)
      if (response.success) {
        const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
        const responseCalculation = await calculation(orderId)
        if (responseCalculation.success) {
          dispatch(getOrderDetail(orderId))
          dispatch(getOrderItems(orderId))
          completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
          notificationSuccess('Upload Product to Order Completed', 'You have been added product to order')
          navigate(`/order/${orderId}`)
        }
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    handleGetListSupplier()
    // eslint-disable-next-line
  }, [searchSupplier])

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    dispatch(getOrderDetail(orderId))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    if (defaultImage) {
      handleChangeForm('image_url', 'https://asiacommerce.s3.ap-southeast-1.amazonaws.com/documents/orders/2688/dev/1637910099-image-loading.png')
    }
  }, [defaultImage])

  useEffect(() => {
    if (useBundle) {
      handleChangeForm('unit_name', 'pak')
      setUseVariant(false)
      setVariantProduct(defaultVariant)
    } else {
      handleChangeForm('unit_name', 'pcs')
    }
  }, [useBundle])

  useEffect(() => {
    if (useVariant) {
      setUseBundle(false)
    } else {
      setVariantProduct(defaultVariant)
    }
  }, [useVariant])
  
  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleChangeVariant = (indexVariant, labelName, value) => {
    const dataVariant = variantProduct
    const remapForm = dataVariant.map((val, index) => {
      if (index === indexVariant) {
        return {
          ...val,
          [labelName]: value
        }
      } else {
        return val
      }
    })
    setVariantProduct([...remapForm])
  }
  
  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const mappingFormBundle = (bundleProduct) => {
    if (bundleProduct) {
      return (
        <SimpleGrid cols={4} verticalSpacing="md" spacing="xs" mb='md'>
          <Box>
            <Select
              name='unit_name'
              value={formData.unit_name}
              label='Unit Name'
              placeholder='Select unit name'
              data={bundleUnit}
              onChange={(val) => handleChangeForm('unit_name', val)}
              size='xs'
              error={validationForm.unit_name.isError ? `${validationForm.unit_name.message}` : ''}
              withAsterisk
              allowDeselect={false}
            />
          </Box>
          <Box>
            <NumberInput
              name='quantity'
              label="Quantity"
              value={formData.quantity}
              rightSection={<Text fz='xs' c='black' tt='capitalize'>{formData.unit_name}</Text>}
              placeholder='Input quantity'
              onChange={(val) => handleChangeForm('quantity', val)}
              error={validationForm.quantity.isError ? `${validationForm.quantity.message}` : ''}
              size='xs'
              withAsterisk
              rightSectionWidth={40}
            />
          </Box>
          <Box>
            <Select
              name='base_unit_name'
              value={formData.base_unit_name}
              label='Base Unit Name'
              placeholder='Select base unit name'
              data={quantityUnit}
              onChange={(val) => handleChangeForm('base_unit_name', val)}
              size='xs'
              error={validationForm.base_unit_name.isError ? `${validationForm.base_unit_name.message}` : ''}
              withAsterisk
              allowDeselect={false}
            />
          </Box>
          <Box>
            <NumberInput
              name='quantity_per_unit'
              label="Quantity Per Unit"
              value={formData.quantity_per_unit}
              rightSection={<Text fz='xs' c='black' tt='capitalize'>{formData.base_unit_name}</Text>}
              placeholder='Input quantity per unit'
              onChange={(val) => handleChangeForm('quantity_per_unit', val)}
              error={validationForm.quantity_per_unit.isError ? `${validationForm.quantity_per_unit.message}` : ''}
              size='xs'
              withAsterisk
              rightSectionWidth={40}
            />
          </Box>
        </SimpleGrid>
      )
    } else {
      return (
        <SimpleGrid cols={3} verticalSpacing="md" spacing="xs" mb='md'>
          <Box>
            <Select
              name='unit_name'
              value={formData.unit_name}
              label='Unit Name'
              placeholder='Select unit name'
              data={quantityUnit}
              onChange={(val) => handleChangeForm('unit_name', val)}
              size='xs'
              error={validationForm.unit_name.isError ? `${validationForm.unit_name.message}` : ''}
              withAsterisk
              allowDeselect={false}
            />
          </Box>
          <Box>
            <NumberInput
              name='quantity'
              label="Quantity"
              value={formData.quantity}
              rightSection={<Text fz='xs' c='black' tt='capitalize'>{formData.unit_name}</Text>}
              placeholder='Input quantity'
              onChange={(val) => handleChangeForm('quantity', val)}
              error={validationForm.quantity.isError ? `${validationForm.quantity.message}` : ''}
              size='xs'
              withAsterisk
              rightSectionWidth={40}
            />
          </Box>
        </SimpleGrid>
      )
    }
  }

  const mappingFormVariant = (useVariant) => {
    if (useVariant) {

      const handleAddVariant = () => {
        setValidationVariant(variantValidation)
        const dataVariant = variantProduct
        const payloadVariant = {
          name: '',
          option: ''
        }
        dataVariant.push(payloadVariant)
        setVariantProduct([...dataVariant])
      }

      const handleRemoveVariant = (indexVariant) => {
        setValidationVariant(variantValidation)
        const dataVariant = variantProduct
        dataVariant.splice(indexVariant, 1)
        setVariantProduct([...dataVariant])
      }

      const showFormVariant = () => {
        const remapVariant = variantProduct.map((val, index) => {
          return (
            <Box key={index} mb={8}>
              <SimpleGrid cols={2} verticalSpacing="md" spacing="xs">
                <Box>
                  <TextInput
                    value={variantProduct[index].name}
                    label={`Variant Option ${index + 1}`}
                    placeholder='Example: Color, Size, Storage'
                    onChange={(val) => handleChangeVariant(index, `name`, val.target.value)}
                    error={validationVariant.name.isError ? `${validationVariant.name.message}` : ''}
                    withAsterisk
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    value={variantProduct[index].option}
                    label={`Variant Option Value ${index + 1}`}
                    placeholder='Example: Red, Green, Blue, Small, Medium'
                    onChange={(val) => handleChangeVariant(index, `option`, val.target.value)}
                    error={validationVariant.option.isError ? `${validationVariant.option.message}` : ''}
                    withAsterisk
                    size='xs'
                  />
                </Box>
              </SimpleGrid>
              <Box mt={8} h={30}>
                <Button size='compact-xs' variant='outline' leftSection={<IconTrash size={12} />} disabled={index === 0} onClick={() => handleRemoveVariant(index)}>Remove Variant</Button>
              </Box>
            </Box>
          )
        })
        return remapVariant
      }

      return (
        <Box mb='md'>
          <Flex justify='space-between' align='center' mb={14}>
            <Text fz={16} fw='bold' mb={14}>Variant</Text>
            <Button size='xs' onClick={() => handleAddVariant()} disabled={variantProduct.length > 2}>Add Variant</Button>
          </Flex>
          <Box my={10}>
            {showFormVariant()}
          </Box>
        </Box>
      )
    }
  }

  if (!isLoadingOrder) {
    return (
      <AuthLayout>
        <Box my={20}>
          <Text className={classes.titleLayout} mb={30}>Add Product Manual</Text>
          <Box mb='md'>
            <Paper shadow="sm" radius="md" withBorder p="md">
              <Text fz={16} fw='bold' mb={14}>Product Information</Text>
              <Box mb='md'>
                <TextInput
                  name='product_name'
                  value={formData.product_name}
                  label='Product Name'
                  placeholder='Input Product Name'
                  error={validationForm.product_name.isError ? `${validationForm.product_name.message}` : ''}
                  onChange={(val) => handleChangeForm('product_name', val.target.value)}
                  withAsterisk
                  size='xs'
                />
              </Box>
              <Box mb='md'>
                <TextInput
                  name='original_name'
                  value={formData.original_name}
                  label='Original Product Name'
                  placeholder='Input Product Name'
                  error={validationForm.original_name.isError ? `${validationForm.original_name.message}` : ''}
                  onChange={(val) => handleChangeForm('original_name', val.target.value)}
                  withAsterisk
                  size='xs'
                />
              </Box>
              <Box mb='md'>
                <NumberInput
                  label="Original Price"
                  placeholder='Input original price'
                  value={formData.original_price}
                  leftSection={<Text fz={12} c='black' tt='capitalize'>{summary.goodsCurrency}</Text>}
                  leftSectionWidth={40}
                  onChange={(val) => handleChangeForm('original_price', val)}
                  error={validationForm.original_price.isError ? `${validationForm.original_price.message}` : ''}
                  thousandSeparator=","
                  size='xs'
                  withAsterisk
                />
              </Box>
              <Box mb='md'>
                <NumberInput
                  label="Price"
                  placeholder='Input price'
                  value={formData.price}
                  leftSection={<Text fz={12} c='black' tt='capitalize'>{summary.orderCurrency}</Text>}
                  leftSectionWidth={40}
                  onChange={(val) => handleChangeForm('price', val)}
                  error={validationForm.price.isError ? `${validationForm.price.message}` : ''}
                  thousandSeparator=","
                  size='xs'
                  withAsterisk
                />
              </Box>
              <Box mb='md'>
                <Select
                  name='supplier_id'
                  value={formData.supplier_id}
                  label='Supplier'
                  data={supplierList}
                  onChange={(val) => handleChangeForm('supplier_id', val)}
                  size='xs'
                  searchable
                  searchValue={searchSupplier}
                  onSearchChange={setSearchSupplier}
                  nothingFoundMessage={!loadingSupplier ? supplierList.length > 0 ? '' : 'No Supplier Found' : loadingDataTemplate()}
                  clearable
                />
              </Box>
              <Box mb='md'>
                <TextInput
                  name='image_url'
                  value={formData.image_url}
                  label='Product Image URL'
                  placeholder='Input product image url'
                  error={validationForm.image_url.isError ? `${validationForm.image_url.message}` : ''}
                  onChange={(val) => handleChangeForm('image_url', val.target.value)}
                  withAsterisk
                  size='xs'
                  disabled={defaultImage}
                  mb={10}
                />
                <Checkbox
                  checked={defaultImage}
                  onChange={(event) => setDefaultImage(event.currentTarget.checked)}
                  size='xs'
                  label="Use Default Product Image"
                />
              </Box>
            </Paper>
          </Box>
          <Box mb='md'>
            <Paper shadow="sm" radius="md" withBorder p="md">
              <Box mb='md'>
                <Switch
                  checked={useBundle}
                  onChange={(event) => setUseBundle(event.currentTarget.checked)}
                  label='Enable Bundle'
                  size='xs'
                />
              </Box>
              {mappingFormBundle(useBundle)}
            </Paper>
          </Box>
          <Box mb='md'>
            <Paper shadow="sm" radius="md" withBorder p="md">
              <Flex justify='space-between' align='center' mb={14}>
                <Text fz={16} fw='bold'>Order Rule</Text>
                <Text fz={12} fw={500}>* Insert 0 if there is no tax</Text>
              </Flex>
              <SimpleGrid cols={2} verticalSpacing="md" spacing="xs" mb='md'>
                <Box>
                  <NumberInput
                    name='weight'
                    label="Weight (Kg)"
                    value={formData.weight}
                    rightSection={<Text fz='xs' c='black' tt='capitalize'>Kg</Text>}
                    placeholder='Input weight'
                    onChange={(val) => handleChangeForm('weight', val)}
                    error={validationForm.weight.isError ? `${validationForm.weight.message}` : ''}
                    size='xs'
                    withAsterisk
                    rightSectionWidth={40}
                  />
                </Box>
                <Box>
                  <NumberInput
                    name='cbm_per_unit'
                    label="CBM Per Unit"
                    value={formData.cbm_per_unit}
                    rightSection={<Text fz='xs' c='black'>m3</Text>}
                    placeholder='Input cbm per unit'
                    onChange={(val) => handleChangeForm('cbm_per_unit', val)}
                    error={validationForm.cbm_per_unit.isError ? `${validationForm.cbm_per_unit.message}` : ''}
                    size='xs'
                    withAsterisk
                    rightSectionWidth={40}
                  />
                </Box>
              </SimpleGrid>
              <SimpleGrid cols={3} verticalSpacing="md" spacing="xs" mb='md'>
                <Box>
                  <NumberInput
                    name='bm'
                    label="BM"
                    value={formData.bm}
                    rightSection={<Text fz='xs' c='black' tt='capitalize'>%</Text>}
                    placeholder='Input bm'
                    onChange={(val) => handleChangeForm('bm', val)}
                    error={validationForm.bm.isError ? `${validationForm.bm.message}` : ''}
                    size='xs'
                    withAsterisk
                    rightSectionWidth={40}
                  />
                </Box>
                <Box>
                  <NumberInput
                    name='pph'
                    label="PPH"
                    value={formData.pph}
                    rightSection={<Text fz='xs' c='black' tt='capitalize'>%</Text>}
                    placeholder='Input pph'
                    onChange={(val) => handleChangeForm('pph', val)}
                    error={validationForm.pph.isError ? `${validationForm.pph.message}` : ''}
                    size='xs'
                    withAsterisk
                    rightSectionWidth={40}
                  />
                </Box>
                <Box>
                  <NumberInput
                    name='ppn'
                    label="PPN"
                    value={formData.ppn}
                    rightSection={<Text fz='xs' c='black' tt='capitalize'>%</Text>}
                    placeholder='Input ppn'
                    onChange={(val) => handleChangeForm('ppn', val)}
                    error={validationForm.ppn.isError ? `${validationForm.ppn.message}` : ''}
                    size='xs'
                    withAsterisk
                    rightSectionWidth={40}
                  />
                </Box>
              </SimpleGrid>
            </Paper>
          </Box>
          <Box mb='md'>
            <Paper shadow="sm" radius="md" withBorder p="md">
              <Box mb='md'>
                <Switch
                  checked={useVariant}
                  onChange={(event) => setUseVariant(event.currentTarget.checked)}
                  label='Enable Variant'
                  size='xs'
                />
              </Box>
              {mappingFormVariant(useVariant)}
            </Paper>
          </Box>
          <Box mt={20}>
            <Flex justify='flex-end'>
              <Group>
                <Button size='xs' variant="outline" onClick={() => navigate(`/order/${orderId}`)}>Back to Detail Order</Button>
                <Button size='xs' loading={loadingForm} variant="filled" onClick={() => handleSubmitProduct(formData)}>Submit</Button>
              </Group>
            </Flex>
          </Box>
        </Box>
      </AuthLayout>
    )
  }
}

export default FormAddProductManual